// import React, { useState, useEffect } from 'react';
// import './Dashboard.css';
// import './OrderHistory.css';

// import { HiOutlineChevronRight } from "react-icons/hi";
// import Dashboardmy from '../Dashboard-component/Dashboard';
// import { HiOutlineChevronLeft } from "react-icons/hi";
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { getWithTokenAPI } from '../../util/Api';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// function Order() {
//     const navigate = useNavigate();
//     const [orders, setOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const accessToken = useSelector((state) => state.auth?.auth?.access_token);
//     const userid = useSelector((state) => state.auth?.auth?._id);
//     const ordersPerPage = 4;
//     const [currentPage, setCurrentPage] = useState(1);

//     useEffect(() => {
//         if (!accessToken || !userid) {
//             toast.error('Please login to view orders');
//             navigate('/login');
//             return;
//         }
//         fetchOrders();
//     }, [accessToken, userid]);

//     const fetchOrders = async () => {
//         try {
//             setLoading(true);
//             const response = await getWithTokenAPI(accessToken, `/order/find-all?buyer_id=${userid}`);
//             if (response?.statusCode === 200 && response.data?.orders) {
//                 setOrders(response.data.orders);
//             } else {
//                 console.error('Invalid response format:', response);
//                 toast.error('Failed to fetch orders: Invalid response format');
//             }
//         } catch (error) {
//             console.error('Error fetching orders:', error);
//             if (error?.response?.status === 401) {
//                 toast.error('Session expired. Please login again');
//                 navigate('/login');
//             } else {
//                 toast.error('Failed to fetch orders. Please try again later');
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     const formatDate = (dateString) => {
//         try {
//             const date = new Date(dateString);
//             if (isNaN(date.getTime())) {
//                 return 'Invalid Date';
//             }
//             return date.toLocaleDateString('en-US', {
//                 year: 'numeric',
//                 month: 'short',
//                 day: 'numeric'
//             });
//         } catch (error) {
//             console.error('Error formatting date:', error);
//             return 'Invalid Date';
//         }
//     };

//     const getStatusClass = (status) => {
//         if (!status) return '';
//         const statusLower = status.toLowerCase();
//         switch (statusLower) {
//             case 'pending':
//                 return 'pending';
//             case 'shipped':
//                 return 'shipped';
//             case 'delivered':
//                 return 'delivered';
//             default:
//                 return '';
//         }
//     };

//     const totalPages = Math.ceil(orders.length / ordersPerPage);
//     const startIndex = (currentPage - 1) * ordersPerPage;
//     const currentOrders = orders.slice(startIndex, startIndex + ordersPerPage);

//     const handlePageChange = (page) => {
//         if (page >= 1 && page <= totalPages) {
//             setCurrentPage(page);
//         }
//     };

//     if (loading) {
//         return <div className="loading">Loading...</div>;
//     }

//     return (
//         <>
//             <ToastContainer autoClose={3000} />
//             <div className='show-content'>
//                 <Dashboardmy />
//                 <div className="order-history">
//                     <div className="show-head">
//                         <h2>Order History</h2>
//                     </div>
//                     {orders.length > 0 ? (
//                         <>
//                             <table className="order-table">
//                                 <thead>
//                                     <tr>
//                                         <th>Order ID</th>
//                                         <th>Date</th>
//                                         <th>Status</th>
//                                         <th>Payment Method</th>
//                                         <th>Payment Status</th>
//                                         <th>Shipping</th>
//                                         <th></th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {currentOrders.map((order) => (
//                                         <tr key={order._id}>
//                                             <td>{order.order_id}</td>
//                                             <td>{formatDate(order.created_at)}</td>
//                                             <td>
//                                                 <span className={`status-badge ${getStatusClass(order.order_status)}`}>
//                                                     {order.order_status}
//                                                 </span>
//                                             </td>
//                                             <td>{order.payment_method}</td>
//                                             <td>
//                                                 <span className={`status-badge ${getStatusClass(order.payment_status)}`}>
//                                                     {order.payment_status}
//                                                 </span>
//                                             </td>
//                                             <td>{order.shipping}</td>
//                                             <td>
//                                                 <button 
//                                                     className="view-order-btn" 
//                                                     onClick={() => { navigate(`/orderdetail?_id=${order._id}&order_id=${order.order_id}&buyer_id=${order.buyer_id._id}`) }}
//                                                 >
//                                                     View Details
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                             {/* Pagination */}
//                             <div className="pagination">
//                                 <button
//                                     className="page-btn"
//                                     onClick={() => handlePageChange(currentPage - 1)}
//                                     disabled={currentPage === 1}
//                                 >
//                                     <HiOutlineChevronLeft />
//                                 </button>
//                                 {[...Array(totalPages)].map((_, index) => (
//                                     <button
//                                         key={index}
//                                         className={`page-btn ${currentPage === index + 1 ? 'active' : ''}`}
//                                         onClick={() => handlePageChange(index + 1)}
//                                     >
//                                         {index + 1}
//                                     </button>
//                                 ))}
//                                 <button
//                                     className="page-btn"
//                                     onClick={() => handlePageChange(currentPage + 1)}
//                                     disabled={currentPage === totalPages}
//                                 >
//                                     <HiOutlineChevronRight />
//                                 </button>
//                             </div>
//                         </>
//                     ) : (
//                         <div className="no-orders">
//                             <p>No orders found</p>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </>
//     );
// }

// export default Order;
// import React, { useState, useEffect } from 'react';
// import './Dashboard.css';
// import './OrderHistory.css';
// import { MdDashboard } from "react-icons/md";
// import { FaSyncAlt } from "react-icons/fa";
// import { FaRegHeart } from "react-icons/fa6";
// import { HiOutlineShoppingBag } from "react-icons/hi2";
// import { IoSettingsOutline } from "react-icons/io5";
// import { BiLogIn } from "react-icons/bi";
// import { HiOutlineChevronRight } from "react-icons/hi";
// import Dashboardmy from '../Dashboard-component/Dashboard';
// import { HiOutlineChevronLeft } from "react-icons/hi";
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { getWithTokenAPI } from '../../util/Api';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// function Order() {
//     const navigate = useNavigate();
//     const [orders, setOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const accessToken = useSelector((state) => state.auth?.auth?.access_token);
//     const userid = useSelector((state) => state.auth?.auth?._id);
//     const ordersPerPage = 4;
//     const [currentPage, setCurrentPage] = useState(1);

//     useEffect(() => {
//         if (!accessToken || !userid) {
//             toast.error('Please login to view orders');
//             navigate('/login');
//             return;
//         }
//         fetchOrders();
//     }, [accessToken, userid]);

//     const fetchOrders = async () => {
//         try {
//             setLoading(true);
//             const response = await getWithTokenAPI(accessToken, `/order/find-all?user_id=${userid}`);
//             if (response?.statusCode === 200 && response.data?.orders) {
//                 setOrders(response.data.orders);
//             } else {
//                 console.error('Invalid response format:', response);
//                 toast.error('Failed to fetch orders: Invalid response format');
//             }
//         } catch (error) {
//             console.error('Error fetching orders:', error);
//             if (error?.response?.status === 401) {
//                 toast.error('Session expired. Please login again');
//                 navigate('/login');
//             } else {
//                 toast.error('Failed to fetch orders. Please try again later');
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     const formatDate = (dateString) => {
//         try {
//             const date = new Date(dateString);
//             if (isNaN(date.getTime())) {
//                 return 'Invalid Date';
//             }
//             return date.toLocaleDateString('en-US', {
//                 year: 'numeric',
//                 month: 'short',
//                 day: 'numeric'
//             });
//         } catch (error) {
//             console.error('Error formatting date:', error);
//             return 'Invalid Date';
//         }
//     };

//     const getStatusClass = (status) => {
//         if (!status) return '';
//         const statusLower = status.toLowerCase();
//         switch (statusLower) {
//             case 'pending':
//                 return 'pending';
//             case 'shipped':
//                 return 'shipped';
//             case 'delivered':
//                 return 'delivered';
//             default:
//                 return '';
//         }
//     };

//     const totalPages = Math.ceil(orders.length / ordersPerPage);
//     const startIndex = (currentPage - 1) * ordersPerPage;
//     const currentOrders = orders.slice(startIndex, startIndex + ordersPerPage);

//     const handlePageChange = (page) => {
//         if (page >= 1 && page <= totalPages) {
//             setCurrentPage(page);
//         }
//     };

//     if (loading) {
//         return <div className="loading">Loading...</div>;
//     }

//     return (
//         <>
//             <ToastContainer autoClose={3000} />
//             <div className='show-content'>
//                 <Dashboardmy />
//                 <div className="order-history">
//                     <div className="show-head">
//                         <h2>Order History</h2>
//                     </div>
//                     {orders.length > 0 ? (
//                         <>
//                             <table className="order-table">
//                                 <thead>
//                                     <tr>
//                                         <th>Order ID</th>
//                                         <th>Date</th>
//                                         <th>Status</th>
//                                         <th>Payment Method</th>
//                                         <th>Payment Status</th>
//                                         <th>Shipping</th>
//                                         <th></th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {currentOrders.map((order) => (
//                                         <tr key={order._id}>
//                                             <td>{order._id}</td>
//                                             <td>{formatDate(order.created_at)}</td>
//                                             <td>
//                                                 <span className={`status-badge ${getStatusClass(order.order_status)}`}>
//                                                     {order.order_status}
//                                                 </span>
//                                             </td>
//                                             <td>{order.payment_method}</td>
//                                             <td>
//                                                 <span className={`status-badge ${getStatusClass(order.payment_status)}`}>
//                                                     {order.payment_status}
//                                                 </span>
//                                             </td>
//                                             <td>{order.shipping}</td>
//                                             <td>
//                                                 <button 
//                                                     className="view-order-btn" 
//                                                     onClick={() => { navigate(`/orderdetail?_id=${order._id}`) }}
//                                                 >
//                                                     View Details
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                             {/* Pagination */}
//                             <div className="pagination">
//                                 <button
//                                     className="page-btn"
//                                     onClick={() => handlePageChange(currentPage - 1)}
//                                     disabled={currentPage === 1}
//                                 >
//                                     <HiOutlineChevronLeft />
//                                 </button>
//                                 {[...Array(totalPages)].map((_, index) => (
//                                     <button
//                                         key={index}
//                                         className={`page-btn ${currentPage === index + 1 ? 'active' : ''}`}
//                                         onClick={() => handlePageChange(index + 1)}
//                                     >
//                                         {index + 1}
//                                     </button>
//                                 ))}
//                                 <button
//                                     className="page-btn"
//                                     onClick={() => handlePageChange(currentPage + 1)}
//                                     disabled={currentPage === totalPages}
//                                 >
//                                     <HiOutlineChevronRight />
//                                 </button>
//                             </div>
//                         </>
//                     ) : (
//                         <div className="no-orders">
//                             <p>No orders found</p>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </>
//     );
// }

// export default Order;
import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import './OrderHistory.css';
import './order.css';
import { Helmet } from 'react-helmet';
import { HiOutlineChevronRight, HiOutlineChevronLeft } from "react-icons/hi";
import Dashboardmy from '../Dashboard-component/Dashboard';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getWithTokenAPI } from '../../util/Api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Order() {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const accessToken = useSelector((state) => state.auth?.auth?.access_token);
    const userid = useSelector((state) => state.auth?.auth?._id);
    const [currentPage, setCurrentPage] = useState(1);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const username = useSelector((state) => state.auth?.auth?.name);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!accessToken || !userid) {
            toast.error('Please login to view orders');
            navigate('/login');
            return;
        }
        fetchOrders();
    }, [accessToken, userid]);

    const fetchOrders = async () => {
        try {
            setLoading(true);
            const response = await getWithTokenAPI(accessToken, `/order/find-all?buyer_id=${userid}`);
            if (response?.statusCode === 200 && response.data?.orders) {
                setOrders(response.data.orders);
            } else {
                console.error('Invalid response format:', response);
                toast.error('Failed to fetch orders: Invalid response format');
            }
        } catch (error) {
            console.error('Error fetching orders:', error);
            if (error?.response?.status === 401) {
                toast.error('Session expired. Please login again');
                navigate('/login');
            } else {
                toast.error('Failed to fetch orders. Please try again later');
            }
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                return 'Invalid Date';
            }
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch (error) {
            console.error('Error formatting date:', error);
            return 'Invalid Date';
        }
    };

   const getStatusClass = (status) => {
        if (!status) return '';
        const statusLower = status.toLowerCase();
        switch (statusLower) {
            case 'pending':
                return 'status-pending'; // Renamed to be more descriptive
            case 'shipped':
                return 'status-shipped'; // Renamed
            case 'delivered':
                return 'status-delivered'; // Renamed
            case 'paid': // Add this new case for "Paid" status
                return 'status-paid';
            default:
                return '';
        }
    };

    const ordersPerPage = isMobile ? 3 : 4;
    const totalPages = Math.ceil(orders.length / ordersPerPage);
    const startIndex = (currentPage - 1) * ordersPerPage;
    const currentOrders = orders.slice(startIndex, startIndex + ordersPerPage);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <>
            <ToastContainer autoClose={3000} />
            <Helmet>
                <title>{`${username} | Order History`}</title>
                <meta name="description" content={`user order history page of Shambasync`} />
            </Helmet>
            <div className='show-content'>
                <Dashboardmy />
                <div className="order-history">
                    <div className="show-head p-2">
                        <h2>Order History</h2>
                    </div>
                    {orders.length > 0 ? (
                        <>
                            {isMobile ? (
                                <div className="mobile-orders">
                                    {currentOrders.map((order) => (
                                        <div key={order._id} className="mobile-order-card">
                                            <div className="mobile-order-row">
                                                <span className="mobile-order-label">Order ID:</span>
                                                <span className="mobile-order-value">{order.order_id}</span>
                                            </div>
                                            <div className="mobile-order-row">
                                                <span className="mobile-order-label">Date:</span>
                                                <span className="mobile-order-value">{formatDate(order.created_at)}</span>
                                            </div>
                                            <div className="mobile-order-row">
                                                <span className="mobile-order-label">Status:</span>
                                                <span className={`mobile-order-value status-badge ${getStatusClass(order.order_status)}`}>
                                                    {order.order_status}
                                                </span>
                                            </div>
                                            <div className="mobile-order-row">
                                                <span className="mobile-order-label">Payment:</span>
                                                <span className="mobile-order-value">{order.payment_method}</span>
                                            </div>
                                            <div className="mobile-order-row">
                                                <span className="mobile-order-label">Payment Status:</span>
                                                <span className={`mobile-order-value status-badge ${getStatusClass(order?.cart_id?.payment_status)}`}>
                                                    {order?.cart_id?.payment_status}
                                                </span>
                                            </div>
                                            <button
                                                className="mobile-view-order-btn"
                                                onClick={() => { navigate(`/orderdetail?_id=${order._id}`) }}
                                            >
                                                View Details
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <table className="order-table">
                                    <thead>
                                        <tr>
                                            <th>Order ID</th>
                                            <th>Date</th>
                                            <th>Status</th>
                                            <th>Payment Method</th>
                                            <th>Payment Status</th>
                                            {/* <th>Shipping</th> */}
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentOrders.map((order) => (
                                            <tr key={order._id}>
                                                <td>{order.order_id}</td>
                                                <td>{formatDate(order.created_at)}</td>
                                                <td>
                                                    <span className={`status-badge ${getStatusClass(order.order_status)}`}>
                                                        {order.order_status}
                                                    </span>
                                                </td>
                                                <td>{order.payment_method}</td>
                                                <td>
                                                    <span className={`status-badge ${getStatusClass(order?.cart_id?.payment_status)}`}>
                                                        {order?.cart_id?.payment_status}
                                                    </span>
                                                </td>
                                                {/* <td>{order.shipping}</td> */}
                                                <td>
                                                    <button
                                                        className="view-order-btn"
                                                        onClick={() => { navigate(`/orderdetail?_id=${order._id}&order_id=${order.order_id}&buyer_id=${order.buyer_id._id}&buyer_name=${order.buyer_id.name}`) }}
                                                    >
                                                        View Details
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}

                            {/* Pagination */}
                            <div className="pagination">
                                
                                <button
                                    className="page-btn"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    <HiOutlineChevronLeft />
                                </button>
                                {[...Array(totalPages)].map((_, index) => (
                                    <button
                                        key={index}
                                        className={`page-btn ${currentPage === index + 1 ? 'active' : ''}`}
                                        onClick={() => handlePageChange(index + 1)}
                                    >
                                        {index + 1}
                                    </button>
                                ))}
                                <button
                                    className="page-btn"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                >
                                    <HiOutlineChevronRight />
                                </button>
                                
                            </div>
                        </>
                    ) : (
                        <div className="no-orders">
                            <p>No orders found</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default Order;